import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { BaseErrorHandler } from '@core/interceptors/base.error-handler';
import { throwError } from 'rxjs';
import { TErrorHandlerFn } from '@core/interceptors/types/handler.fn.type';
import { APIErrorErrorResponse } from '@shared/models/base-api.model';

const DEFAULT_REFRESH_URL_BLACKLIST = ['login', 'logout', 'token', 'assets', 'session-refresh'];
const STATUS_HANDLERS: Partial<Record<HttpStatusCode, TErrorHandlerFn>> = {
    [HttpStatusCode.NotFound]: (h) => h.handle404(),
    [HttpStatusCode.InternalServerError]: (h) => h.handleApiError()
} as const;

function isHttpError(e: unknown): e is APIErrorErrorResponse {
    return e instanceof APIErrorErrorResponse;
}

function isBlacklisted(url: string): boolean {
    return DEFAULT_REFRESH_URL_BLACKLIST.some((term) => url.includes(term));
}

export const errorCatchingInterceptor: HttpInterceptorFn = (req, next) => {
    const handler = inject(BaseErrorHandler);

    return next(req).pipe(
        catchError((err: APIErrorErrorResponse) => {
            const { url } = err;
            const uri = url ?? '';

            if (isBlacklisted(uri)) {
                return throwError(() => err);
            }

            if (!isHttpError(err)) {
                handler.handleError(err);
                return throwError(() => err);
            }
            const fn = STATUS_HANDLERS[err.status as HttpStatusCode] ?? ((h, e) => h.handleError(e));
            fn(handler, err);
            return throwError(() => err);
        })
    );
};
